<template>
<div>
  <div class="row">
    <div class="alert alert-danger" v-for="error in errors" :key="error.id">
      <strong>Woops !</strong> {{ error[0] }}
    </div>

    <div class="col-md-8 col-md-offset-2 col-xs-12">
      <div class="form-group " >
        
          <label class="form-label">Nom du programme</label>
       
        <input type="text" class="form-control" v-model="program.name" @blur="addProgram()" placeholder="Ajouter un nom à votre programme"/>
        <span class="help-block"></span>
      </div>
      <span class="help-block"></span>
    </div>

    <div class="col-md-8 col-md-offset-2 col-xs-12">
      <div class="" >
        <div class="ss-titre">
            <strong>Ajouter des activités au programme</strong>
        </div>
        <div class="row">
          <div class="form-group  col-md-7 col-xs-12" style=" max-width: 320px; " >
            <label class="form-label">Choisissez une activité :</label>
            <select :disabled = 'isDisabled' name="activity" class="form-control" v-model="detail.activity" >
                <option v-for="activity in activities" :key="activity.id" :value="activity">{{ activity.name }}</option>
            </select>
            <span class="help-block"></span>
          </div>
          </div>
          <div class="row">
          <div class="form-group form-2-col col-md-4 col-xs-12" style=" max-width: 320px; ">
              <label class="form-label" >Date de début de l'activité:</label>
              <datepicker :disabled = 'isDisabled' :bootstrapStyling="true" v-model="detail.date_begin" name="details__input" format="yyyy-MM-dd" full-month-name monday-first v-on:keypress.enter.prevent="addDetail()"></datepicker>
              <span class="help-block"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <button :disabled = 'isDisabled' class="btn btn-block btn-primary" v-if="detailMode === 'post' || detailMode === 'delete'" @click.prevent="addDetail()" id="detail_button">Ajouter</button>

            <button class="btn btn-block btn-primary" v-if="detailMode === 'put'" @click.prevent="updateDetail()" id="update_detail_button">Modifier</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-8 col-md-offset-2 col-xs-12">
      <div class="" >
        <div class="ss-titre">
            <strong>Activités liés au programme</strong>
        </div>
          <div class="images">
            <div v-for="detail in details" :key="detail.id" class="myOverlay boxShadow" @mouseenter="hover = detail.id" @mouseleave="hover = null">
              <img :src="hostname + detail.activity.images[0].optimized" class="cover" alt="image de l'activité">
              <div class="customPosTitle">
                  <p class="glow uppercase bold"><span>{{detail.date.date_begin}}</span><br>{{detail.activity.name}}</p>
              </div>
              <transition name="fade">
                <div class="myOverlay-inner hidden-xs" v-if="hover === detail.id">
                  <div class="OverlayInnerItems">
                    <div>
                      <a class="btn default btn-outline glow slide-in-top" href="javascript:;" @click="deleteDetail(detail)">
                        <i class="icon-trash"></i>
                      </a>
                    </div>
                    <div>
                      <a class="btn default btn-outline glow slide-in-top" href="javascript:;" @click="editDetail(detail)">
                        <i class="icon-pencil"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="myOverlay-inner visible-xs">
                  <div class="OverlayInnerItems">
                    <div>
                      <a class="btn default btn-outline glow slide-in-top" href="javascript:;" @click="deleteDetail(detail)">
                        <i class="icon-trash"></i>
                      </a>
                    </div>
                    <div>
                      <a class="btn default btn-outline glow slide-in-top" href="javascript:;" @click="editDetail(detail)">
                        <i class="icon-pencil"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-xs-12">
      <a class="btn green btn-block" @click.prevent="saveCheck(details)">Sauvegarder le programme</a>
    </div>
  </div>
</div>

</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  name: "addProgramActivityComponent",
  props: {
    oldprogram: {
      type: Number,
      default: null
    },
    mode: {
      type: String,
      default: "post"
    },
    activities: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      errors: [],
      details: [],
      detail: {},
      details: [],
      program: Object.assign({}, this.oldprogram),
      programMode: this.mode,
      detailMode: "post",
      hovered: null,
      hover: null,
      hostname: process.env.MIX_APP_URL
    }
  },
  mounted() {
    if (this.oldprogram != null) {
      axios.get(`/program/${this.oldprogram}/get`).then((res) => {
        this.program = res.data
        this.details = res.data.program_step
      })
    }
  },
  computed:{
    isDisabled : function () {
      return (Object.entries(this.program).length === 0 && this.program.constructor === Object)
    }
  },
  methods: {
    sendDetail() {
      axios[this.detailMode](
        this.detailMode === "post"
          ? `/program/${this.program.id}/programstep`
          : `/program/${this.program.id}/programstep/${this.detail.id}`,
        this.detail
      )
      .then(res => {
        if (this.detailMode === "post" || this.detailMode === "put") {
          this.details.push(res.data)
        }
        this.$snotify.success("Programme mis a jour !")
        this.detail = {};
      })
      .catch(err => {
        this.errors = err.response.data.errors
      })
    },
    addProgram() {
      axios[this.programMode](
        this.programMode === "post"
          ? "/program"
          : `/program/${this.program.id}`,
        this.program
      )
        .then(res => {
          this.program = res.data;
          if (this.programMode === "post") {
            this.$snotify.success("Programme sauvegardé !")
            this.programMode = "put";
          } else {
            this.$snotify.success("Programme mis a jour !")
          }
        })
        .catch(err => {
          this.errors = err.response.data.errors
        })
    },
    addDetail() {
      this.detailMode = "post";
      this.detail.date_begin = new Date(this.detail.date_begin)
        .toISOString()
        .slice(0, 10);
      this.sendDetail(this.detail)
    },
    deleteDetail(detail) {
      this.detailMode = "delete"
      this.detail = detail
      this.details.splice(this.details.indexOf(detail), 1)
      this.sendDetail(detail)
    },
    editDetail(detail) {
      this.detailMode = "put"
      this.detail = detail
      this.detail.date_begin = this.detail.date.date_begin
      this.details.splice(this.details.indexOf(detail), 1)
    },
    updateDetail(detail) {
      this.detailMode = "put"
      this.detail.date_begin = new Date(this.detail.date_begin)
        .toISOString()
        .slice(0, 10)
      this.sendDetail(this.detail)
      this.detailMode = "post"
    },
    saveCheck(details) {
      if (this.details.length === 0) {
        this.$snotify.info("Vous devez ajouter au moins une activité")
      } else {
        window.location.href = '/program'
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style lang="css" scoped>



.col-md-offset-2 {
    margin-left: 0;
}
#detail_button #update_detail_button{
  margin-top: 2.5rem;
}
.borderEdit {
  color: red;
  background-color: red;
}
.cover {
  object-fit: cover;
  width: 200px;
  height: 200px;
  border: 1px solid rgb(0, 0, 0);
}
.customPosTitle {
  position: absolute;
  top: 0%;
  right: 0%;
  width: 100%;
  height: 100%;
  background: rgba(4, 58, 70, 0.562);
}
.customPosTitle p {
  text-align: center;
  padding-top: 2em;
  margin: 0 1em;
}
.customPosTitle span {
  color: rgb(199, 200, 158);
  font-style: italic;
  font-size: 14px;
  font-weight: lighter;
  margin-bottom: 1em;
  line-height: 20px;
}
.images {
  display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    margin-right: 20px;
    margin-bottom: 20px;
}
.btn {
  margin-bottom: 2rem;
}
.myOverlay-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.OverlayInnerItems {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
.OverlayInnerItems > div {
  margin: 1em;
}
.myOverlay {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0.5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-in-top {
  -webkit-animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.flip-in-hor-top {
  -webkit-animation: flip-in-hor-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: flip-in-hor-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes flip-in-hor-top {
  0% {
    -webkit-transform: rotateX(-80deg);
    transform: rotateX(-80deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
    opacity: 1;
  }
}
@keyframes flip-in-hor-top {
  0% {
    -webkit-transform: rotateX(-80deg);
    transform: rotateX(-80deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
    opacity: 1;
  }
}
@-webkit-keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
